<template>
  <div class="pageStyle">
    <div class="top-title">
      <span>欢迎加入我们的大家庭！🎉</span>
      <span>
        亲爱的小伙伴们，无论你是初来乍到的萌新，还是带着满满好奇心的探索者，这里都为你准备了一份贴心的办理指引，助你快速开启精彩之旅。</span
      >
    </div>
    <div class="infoBox">
      <div class="box">
        <div
          class="item"
          v-for="(item, index) in dataList"
          :key="index"
          @click="toPage(item.id)"
        >
          <img :src="iconArr[index]" alt="" />
          <span>{{ item.label }}</span>
        </div>
      </div>

      <van-empty description="暂无数据" v-show="!dataList[0]" />
    </div>
  </div>
</template>

<script>
import { getCus as cusGetDict } from "@/api/dictDetail.js";
import Vue from "vue";
import { getWx } from "@/utils/wxJsSdk.js";
import { Empty, Toast } from "vant";
import { xcDepConfig } from "@/api/depConfig.js";
import { getDepNameByDomain } from "@/utils/index";
Vue.use(Empty);
export default {
  data() {
    return {
      dataList: [],
      iconArr: [
        "https://static.xchengtech.cn/787836c8aa67428dae03bc6679c84db8.png",
        "https://static.xchengtech.cn/d2a3e93634d84470822b5cb6aac5e810.png",
        "https://static.xchengtech.cn/431beb2bda85457b8dfdb95cfdd7c6e4.png",
      ],
      depName: "",
      depConfig: {},
      dictName: "operating_manual",
    };
  },

  mounted() {
    this.getShareTxt();
    this.getDepConfig();
  },
  created() {},
  methods: {
    getData() {
      cusGetDict(this.dictName)
        .then((res) => {
          this.dataList = res;
          Toast.clear();
          console.log("res", res);
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    toPage(id) {
      this.$router.push({
        path: "/posterPage",
        query: { id: id, name: this.dictName },
      });
    },
    getShareTxt() {
      let desc = "选择功能查看操作流程";
      let that = this;
      let url = window.location.href;
      getWx().then((res) => {
        window.wx.updateAppMessageShareData({
          title: "办理指引", // 分享标题
          desc: desc, // 分享描述
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://static.xchengtech.cn/4a6254f9d27042ddabb8c7d8c766b9bc.png", // 分享图标
          success: function (res) {
            console.log("res", res);
            //afterShare();
          },
        });
      });
    },
    getDepConfig() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      this.depName = getDepNameByDomain();
      xcDepConfig(this.depName).then((res) => {
        this.depConfig = res;
        // 如果是商协会模式的租户，则使用另一本字典
        if (
          this.depConfig.bizType === "ssh" ||
          this.depConfig.bizType === "csqfpt"
        ) {
          // 分配图标
          this.iconArr = [
            "https://static.xchengtech.cn/787836c8aa67428dae03bc6679c84db8.png",
            "https://static.xchengtech.cn/d2a3e93634d84470822b5cb6aac5e810.png",
            "https://static.xchengtech.cn/b1053db8031e4d0e961e1f471e7527d6.png",
          ];
          // 改变字典名称
          this.dictName = "csqfpt_operating_manual";
        }
        // 获取字典海报数据
        this.getData();
      });
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/operatingManual/index.vue